import React from "react";
import SelectInput from "components/SelectInput";
import { useFormattedMessage } from "hooks";

const BankAccountSelector = ({
    availableBankAccounts = [],
    selectedBankAccountIndex = 0,
    onAccountChange,
    className = "mb-5",
    error,
    errorMessage,
    label,
}) => {
    const { formatMessage } = useFormattedMessage();

    const accountOptions = availableBankAccounts.map((account, index) => ({
        value: index,
        label: `${account.iban} (${account.bic})`,
        iban: account.iban,
        bic: account.bic,
    }));

    const handleAccountChange = (selectedOption) => {
        if (selectedOption && onAccountChange) {
            onAccountChange(selectedOption.value, selectedOption.iban, selectedOption.bic);
        }
    };

    if (availableBankAccounts.length <= 1) {
        return null;
    }

    return (
        <SelectInput
            className={className}
            label={label}
            maxMenuHeight={400}
            isSearchable={false}
            selectClassName="pd-bank-account-select-input"
            classNamePrefix="select"
            name="selectedBankAccount"
            options={accountOptions}
            placeholder={formatMessage({ id: "pleaseSelect" }) || "Please select"}
            value={accountOptions.find((option) => option.value === selectedBankAccountIndex)}
            onChange={handleAccountChange}
            errorMessage={errorMessage}
            error={error}
        />
    );
};

export default BankAccountSelector;
